<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-ttl" id="main-toc">Contents</p>
<p class="toc1"><a class="hlink" href="#/FM">Dream of Freedom</a></p>
<p class="toc1"><span class="hlink" href="#/ch01b" title="Link target outside of Sample">Dream of Life</span></p>
<p class="toc1"><span class="hlink" href="#/ch001" title="Link target outside of Sample">Dream of Love</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main-toc.vue?132063aa